import { SectionDataTable } from '@components/ui';

import { usePurchaseListContext } from '@/modules/purchase/purchase-list/purchase-list.context.tsx';
import { purchaseTableColumns } from '@/modules/purchase/purchase-list/purchase-table.column.tsx';

export const PurchaseTable = () => {
    const { data, isLoading } = usePurchaseListContext();

    return (
        <SectionDataTable
            columns={purchaseTableColumns}
            data={data}
            isLoading={isLoading}
        />
    );
};

PurchaseTable.displayName = 'PurchaseTable';
